import { render, staticRenderFns } from "./Barcode.vue?vue&type=template&id=0bf152b5&scoped=true&"
import script from "./Barcode.vue?vue&type=script&lang=js&"
export * from "./Barcode.vue?vue&type=script&lang=js&"
import style0 from "./Barcode.vue?vue&type=style&index=0&id=0bf152b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf152b5",
  null
  
)

component.options.__file = "Barcode.vue"
export default component.exports